import React from 'react';

const CollapseContext = React.createContext({ collapsed: false });

export default CollapseContext;
